import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Match } from "model/Match/Match";

export interface IMatchSlice {
  data: { [key: string]: Match };
  tournamentIdLookup: { [matchId: string]: string | undefined };
  tournamentsLoaded: string[];
}

const initialState: IMatchSlice = {
  data: {},
  tournamentIdLookup: {},
  tournamentsLoaded: [],
};

export const matchSlice = createSlice({
  name: "match",
  initialState,
  reducers: {
    updateMatches: (
      state,
      action: PayloadAction<{
        matches: Match[];
        tournamentId: string;
      }>
    ) => {
      const { matches, tournamentId } = action.payload;
      for (let i = 0; i < matches.length; i++) {
        const match = matches[i];
        state.data[match.id] = match;
        state.tournamentIdLookup[match.id] = tournamentId;
      }

      if (!state.tournamentsLoaded.includes(tournamentId)) {
        state.tournamentsLoaded.push(tournamentId);
      }
    },
  },
});

export const { updateMatches } = matchSlice.actions;
export const matchReducer = matchSlice.reducer;
